import tagTester from './_tagTester.js';

export default tagTester('ArrayBuffer');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isArrayBuffer.js
// module id = null
// module chunks = 